export default __webpack_public_path__ + "static/media/khoa_cao.40123ebb.jpg";